import { render } from "./quotes-list.vue?vue&type=template&id=ae3df176"
import script from "./quotes-list.vue?vue&type=script&lang=js"
export * from "./quotes-list.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__